import React, { useState } from "react";
import { useGetUsersBank } from "services/accountsService";

import { TransactionSummary } from "../reusables";
import styles from '../wallet.module.css';

const WithdrawSummary = ({onNext, onPrevious, values,...props}) => {
    const {data:userBanks} = useGetUsersBank();
    const banks = userBanks?.data || [];
    const selectedBank = banks.find(bank => bank.id === values.bank);
    const [isLoading ,setIsLoading] = useState()
    const data ={
        "Amount": values.amount || "₦0",
        "Recipient": `${selectedBank.accountName} (${selectedBank.bank})`,
        "Remark":"Cowrie243635",
        "Date" : "12/04/22 15:37"

    }
    const onCompleteHandler = (e) => {
        onNext(e, null, {currency:"ngn",amout: parseFloat(values.amount.replace(/[₦\,]+/g, '') || "0.0"), bank:values.bank});
        
        
    } 

    return (
        <div className={styles.Deposit}>
            <TransactionSummary isLoading={isLoading}

             onComplete={onCompleteHandler} onPrevious={onPrevious} 
            data={data} />
        </div>
    )
}

export default WithdrawSummary;